export default "__VITE_ASSET__BlyYEJ0H__"